import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-captureSettings",
  "use": "icon-captureSettings-usage",
  "viewBox": "0 0 950 950",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 950 950\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-captureSettings\"><path d=\"M0 128v213.333h85.333V896h853.334V213.333H213.333V128H0zm170.667 42.667v128h-128v-128h128zM896 256v597.333H128v-512h85.333V256H896z\" data-spm-anchor-id=\"a313x.search_index.0.i0.7f143a81kaZVkx\" class=\"selected\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol